import {useNavigate} from "react-router-dom";
import PageContainer from "../../containers/PageContainer";
import Input from "../../inputs/Input";
import useTable from "../../../hooks/useTable";
import Alert from "../../../helpers/Alert";
import {useEffect, useState} from "react";
import { FaSearch } from "react-icons/fa";
import Table from "../../Table";
import AddButton from "../../button/AddButton";
import statesApi from "../../../services/statesApi";
import typePropertyApi from "../../../services/typePropertyApi";
import propertyApi from "../../../services/propertyApi";
import InputSelect from "../../inputs/inputSelect";
import cityApi from "../../../services/cityApi";
import vehiclesApi from "../../../services/vehiclesApi";
import AdminContainer from "../../containers/AdminCointainer";
interface IListPageLayout {
    title: string,
    urlReturn?: string;
    urlCreate: string,
    queries?: {
        [key: string]: string
    }
    table: {
        columns: any[];
        loader: any;
    },
    collunSearch?: string;
    properties?: boolean;
    vehicles?: boolean;
    filters?: boolean;
}
export default function ListPageLayout<T = any>(
{
    title,
    urlReturn,
    urlCreate,
    table,
    queries,
    collunSearch,
    properties,
    vehicles,
    filters
}: IListPageLayout) {
    const navigate = useNavigate();
    const [dataSearch, setDataSerach] = useState('');
    const [propertiesDataSearch, setPropertiesDataSerach] = useState({
        tipo_id: '',
        state_id: '',
        city_id: '',
    });
    const [vehiclesDataSearch, setVehiclesDataSerach] = useState({
        marca: '',
        modelo: '',
    });
    const [stateOptions, setStateOptions]: any = useState([])
    const [cityOptions, setCityOptions]: any = useState([]);
    const [typePropertiesOptions, setTypePropertiesOptions]: any = useState([])
    const [loadingDataCity, setLoadingDataCity] = useState(false);
    const [loadOptions, setLoadOptions] = useState(true);
    const { tableProps, loadData } = useTable<T>({
        denyInitialLoad: true,
        dataLoader: async (params) => {
            //const q = searchParams.get("q");
            if (queries){
                params = queries;
            }
            if (properties){
                let whereBig = '';
                if (propertiesDataSearch.tipo_id){
                    whereBig += 'where=tipo_id,=,'+propertiesDataSearch.tipo_id
                }
                if (propertiesDataSearch.state_id){
                    if (whereBig.length){
                        whereBig += '&where=state_id,=,'+propertiesDataSearch.state_id
                    }else{
                        whereBig += 'where=state_id,=,'+propertiesDataSearch.state_id
                    }
                }
                if (propertiesDataSearch.city_id){
                    if (whereBig.length){
                        whereBig += '&where=city_id,=,'+propertiesDataSearch.city_id
                    }else{
                        whereBig += 'where=city_id,=,'+propertiesDataSearch.city_id
                    }
                }

                params = { ...params, whereBig: whereBig };
            }

            if (vehicles) {
                let whereBig = '';
                if (vehiclesDataSearch.marca) {
                    whereBig += 'where=marca,=,' + vehiclesDataSearch.marca
                }

                if (vehiclesDataSearch.modelo) {
                    whereBig += 'where=modelo,=,' + vehiclesDataSearch.modelo
                }

                params = {...params, whereBig: whereBig};

            }



            if (dataSearch) {
                // @ts-ignore
                params = { ...params, like: [collunSearch, dataSearch] };
            }

            // @ts-ignore
            const { data, isError } = await table.loader({...params} as any);
            if (isError) {
                Alert.error(data.message || data.error || 'Falha ao carregar dados.');
                return;
            }
            return data as any;
        }
    });
    useEffect(() => {
        loadData()
    }, [])
    const onClickTable = (data?: any) => {
        navigate(urlCreate+'/'+data.id)
    }

    const getDatas = async () => {
        const [statData, typePropertyData] = await Promise.all([
            statesApi.listAll(),
            typePropertyApi.listAll(),

        ]);
        if (!statData.isError){
            setStateOptions(statData.data.map((dt:any) => {return {value: dt.id, label: dt.description, code: dt.uf}}))
        }
        if (!typePropertyData.isError){
            const opt = typePropertyData.data.map((dt:any) => {return {value: dt.id, label: dt.descricao}});
            opt.unshift({value: '', label: 'Todos'})
            setTypePropertiesOptions(opt)
        }
    }

    useEffect(() => {
        if (properties) {
            getDatas()
        }
    }, [])

    const handleChange = (value: any, input: string) => {
        setPropertiesDataSerach({...propertiesDataSearch, [input]: value});
    };

    const handleChangeVehicles = (value: any, input: string) => {
        setVehiclesDataSerach({...vehiclesDataSearch, [input]: value});
    };

    const getCity = async (idState: number, searchCep?: string) => {
        setLoadingDataCity(true)
        const {data, isError} = await cityApi.getCity(idState);
        if (!isError){
            const dataSelect = data.map((dt:any) => {return {value: dt.id, label: dt.description}});
            setCityOptions(dataSelect)
        }
        setLoadingDataCity(false)
    }

    const onSelectState = (value: any) => {
        const val = value ? value.value : '';
        setPropertiesDataSerach({...propertiesDataSearch, ['state_id']: val});
        if (value){
            getCity(val)
        }
    }


    return(
        <AdminContainer >
            <div className={'p-5 md:flex xs:flex-row border-b items-center justify-between border-system-gray-gray80'}>
                <div className="flex items-center gap-0">
                    {urlReturn && (
                        <button type="button" onClick={() => navigate(urlReturn)}>
                            Voltar
                        </button>
                    )}
                    <div className="text-xl font-bold text-left ml-2"> { }
                        {title}
                    </div>
                </div>
                <div className="flex flex-col md:flex-row items-center gap-2 ">
                    {
                        filters ?
                            properties ?

                                <div className="grid grid-cols-12 gap-5 content-center">
                                    <InputSelect
                                        isClearable
                                        key={(Math.random() + 1).toString(36).substring(7)}
                                        selected={propertiesDataSearch.state_id}
                                        label={'Estado'}
                                        className={'md:col-span-4 xs:col-span-12'}
                                        options={stateOptions}
                                        onChangeSelect={(e: any) => onSelectState(e)}
                                        placeholder={'Estado'}
                                    />
                                    <InputSelect
                                        isClearable
                                        loading={loadingDataCity}
                                        key={(Math.random() + 1).toString(36).substring(7)}
                                        selected={propertiesDataSearch.city_id}
                                        label={'Cidade'}
                                        className={'md:col-span-4 xs:col-span-12'}
                                        options={cityOptions}
                                        onChangeSelect={(e: any) => handleChange(e ? e.value : '', 'city_id')}
                                        placeholder={'Cidade'}
                                    />
                                    <InputSelect
                                        key={(Math.random() + 1).toString(36).substring(7)}
                                        selected={propertiesDataSearch.tipo_id}
                                        label={'Tipo do imóvel'}
                                        className={'md:col-span-3 xs:col-span-12'}
                                        options={typePropertiesOptions}
                                        onChangeSelect={(e: any) => handleChange(e.value, 'tipo_id')}
                                        placeholder={'Tipo de imóvel'}
                                    />
                                    <div className={'flex items-end'}>
                                        <button onClick={loadData} className="w-[50px] h-[50px]">
                                            <FaSearch />
                                        </button>
                                    </div>

                                </div>

                                :

                                vehicles ?

                                    <div className="flex grid-cols-12 gap-5 content-end">
                                        <Input
                                            placeholder="Marca"
                                            className={'md:col-span-4 xs:col-span-12'}
                                            value={vehiclesDataSearch.marca}
                                            setValue={(v) => handleChangeVehicles(v, 'marca')}
                                        />
                                        <Input
                                            placeholder="Modelo"
                                            className={'md:col-span-4 xs:col-span-12'}
                                            value={vehiclesDataSearch.modelo}
                                            setValue={(v) => handleChangeVehicles(v, 'modelo')}
                                        />
                                        <div className={'flex items-end'}>
                                            <button onClick={loadData} className="w-[50px] h-[50px]">
                                                <FaSearch/>
                                            </button>
                                        </div>
                                    </div>
                                    :

                                    <>
                                        <Input
                                            placeholder="Procurar"
                                            className={'w-[25rem]'}
                                            value={dataSearch}
                                            setValue={(v) => setDataSerach(v)}
                                        />
                                        <button onClick={loadData} className="p-2">
                                            <FaSearch />
                                        </button>
                                    </>
                            :
                            ''

                    }


                </div>
            </div>
            <div className="table_component mb-10" role="region">
                <Table
                    {...tableProps}
                    onClick={onClickTable}
                    data={tableProps.data}
                    columns={table.columns}
                />
            </div>
            <AddButton onClick={() => navigate(urlCreate)}/>
        </AdminContainer>
    )
}